var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltip",staticClass:"flex"},[(!_vm.icon)?_vm._t("default"):_c(`Icon-${_vm.icon}`,{tag:"component",class:{
      'text-info-base': _vm.theme == 'default',
      'text-warning-base': _vm.theme == 'warning',
      'text-error-base': _vm.theme == 'error'
    }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }